<ng-container *ngIf="searchResult.entry.isInputHidden && !showHiddenFields; else showValue">
  <mat-icon>block</mat-icon>
  <span class="hidden-field-text ">
    Das Feld kann aktuell nicht ausgewählt/angezeigt werden. Aktivieren Sie den Schalter „Unsichtbare Felder anzeigen“, um dieses Feld darzustellen und zu bearbeiten.
  </span>
</ng-container>

<ng-template #showValue>
  <ng-container *ngIf="!searchResult.entry.isInputHidden">
    <ng-container *ngFor="let node of textNodes">
      <span *ngIf="node.type === 'TEXT'">{{ node.text }}</span>
      <span *ngIf="node.type === 'MARKED'" class="highlight">{{ node.text }}</span>
    </ng-container>
  </ng-container>
</ng-template>
